import * as mime from 'mime-types';

import { ALLOWED_IMAGE_LINK_DOMAINS, ALLOWED_IMAGE_MIME_TYPES } from 'constants/images';
import { getHostname, getQueryParams, findUniqueLinks } from 'util/url';

export const getAllowedImageLinksObjects = (messageBody) => {
  const imageLinks = findAllowedImageLinks(messageBody);
  const imageLinkObjects = prepareImageLinkObjects(imageLinks);

  return filterImageLinkObjectsByType(imageLinkObjects);
};

/*
 * In the long term, we should store a list of image storage domains in the DB;
 * These domains will be fetched and cached on initial load, and use for parsing.
 */
const findAllowedImageLinks = (messageBody) => {
  const links = findUniqueLinks(messageBody);

  const allowedImageLinks = links.filter((link) => {
    const hostname = getHostname(link) || '';

    return ALLOWED_IMAGE_LINK_DOMAINS.some((allowedDomain) => hostname.endsWith(allowedDomain));
  });

  return allowedImageLinks;
};

const prepareImageLinkObjects = (links) => {
  const imageLinkObjects = links.map((link) => {
    const searchString = link.split('?')[1] || '';
    const fileName = getQueryParams(searchString)['name'];
    const mimeType = mime.lookup(fileName);

    return {
      link,
      fileName,
      mimeType,
    };
  });

  return imageLinkObjects;
};

const filterImageLinkObjectsByType = (imageLinkObjects) => {
  return imageLinkObjects.filter((linkObj) => ALLOWED_IMAGE_MIME_TYPES.includes(linkObj.mimeType));
};
